import type { InstanceTarget } from "../contract/definition";
import {
  getMainInstance,
  type ConfiguratorConfiguration,
  type ConfiguratorInstanceContext,
} from "../contract/configuration";

export const resolveInstanceContexts = (
  configuration: ConfiguratorConfiguration,
  target: InstanceTarget = { type: "main" },
): ConfiguratorInstanceContext[] => {
  const mainInstance = getMainInstance(configuration);
  const instances =
    target.type === "main"
      ? [mainInstance]
      : configuration.instances
          .filter((instance) => instance.kind === "sub" && instance.kmatType === target.kmatType)
          .sort((left, right) => left.kmatIndex - right.kmatIndex);

  return instances.map((instance, logicalIndex) => ({
    instance,
    mainInstance,
    logicalIndex,
    instanceCount: instances.length,
  }));
};
